import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Tiny pill-style theme switch for the topbar. Two-icon design (sun + moon)
 * with a sliding gold thumb behind the active state.
 */
export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      role="switch"
      aria-checked={isDark}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      data-testid="theme-toggle"
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      className="relative inline-flex items-center w-[64px] h-9 rounded-full border border-zinc-800 bg-[#141417] hover:border-zinc-600 transition-colors px-1"
    >
      {/* Sliding gold thumb */}
      <span
        className="absolute top-1 h-7 w-7 rounded-full bg-[#D4A968] transition-transform duration-200 ease-out shadow-sm"
        style={{ transform: isDark ? "translateX(0px)" : "translateX(28px)" }}
      />
      <span className="relative z-10 w-7 h-7 flex items-center justify-center">
        <Moon className={`w-3.5 h-3.5 ${isDark ? "text-black" : "text-zinc-400"}`} />
      </span>
      <span className="relative z-10 w-7 h-7 flex items-center justify-center">
        <Sun className={`w-3.5 h-3.5 ${!isDark ? "text-black" : "text-zinc-400"}`} />
      </span>
    </button>
  );
}
